/**
 * Store 入口
 * 导出所有 store 模块
 */
import { createPinia } from 'pinia'

export * from './modules/app'
export * from './modules/user'
export * from './modules/permission'

export const store = createPinia()

export default store
